const globalFn = () => { };

const globalScripts = globalFn;

export { globalScripts as g };
